export default "__VITE_ASSET__d9f47a16__"